// export enum CognitoGroupsTypes {
//     SIZING = 'tk-sizing-ug',
//     COMMVAULT = 'tk-commvault-ug',
//     ADMIN = 'roboproc-dev-admin-ug'
// }
const env_name = process.env.REACT_APP_ENV_VARIABLE || "dev"

export const CognitoGroupsTypes = {
    SIZING : `roboproc-${env_name}-sizing-user-group`,
    COMMVAULT: `roboproc-${env_name}-commvault-user-group`,
    NETWORK: `roboproc-${env_name}-network-user-group`,
    SITE: `roboproc-${env_name}-site-user-group`,
    ADMIN : `roboproc-${env_name}-admin-user-group`,
    SUPER_ADMIN: `roboproc-${env_name}-super-admin-user-group`
}

export const IsProcurementCommsComponentEnable=  (stageName:any, groups:any ) => {
    switch (stageName) {
      case "Sizing":
        return groups.includes(CognitoGroupsTypes.SIZING)|| groups.includes(CognitoGroupsTypes.ADMIN) || groups.includes(CognitoGroupsTypes.SUPER_ADMIN);
      case "Network":
        return groups.includes(CognitoGroupsTypes.NETWORK)|| groups.includes(CognitoGroupsTypes.ADMIN) || groups.includes(CognitoGroupsTypes.SUPER_ADMIN);
      case "CommVault":
        return groups.includes(CognitoGroupsTypes.COMMVAULT)|| groups.includes(CognitoGroupsTypes.ADMIN) || groups.includes(CognitoGroupsTypes.SUPER_ADMIN);
      case "Site":
        return groups.includes(CognitoGroupsTypes.SITE)|| groups.includes(CognitoGroupsTypes.ADMIN) || groups.includes(CognitoGroupsTypes.SUPER_ADMIN);
      case "CommVault_Network":
        return groups.includes(CognitoGroupsTypes.NETWORK)|| groups.includes(CognitoGroupsTypes.ADMIN) || groups.includes(CognitoGroupsTypes.SUPER_ADMIN);
      case "MasterCommVault":
        return groups.includes(CognitoGroupsTypes.COMMVAULT)|| groups.includes(CognitoGroupsTypes.ADMIN) || groups.includes(CognitoGroupsTypes.SUPER_ADMIN);
      default:
        return true;
    }
  };